/**
 * algebra-test/report.js — разбор теста по алгебре (PDF) на экране результата.
 *
 * Карточку рисует ОБЩИЙ примитив <x-perk-gate perk="algebra_report"> (+ perk-gate.js):
 * план заголовком, разовая оплата 99 ₽ второй строкой, токены там, где план уже
 * израсходован. Этот файл делает только то, что знает тул:
 *   • переносит карточку в слот результата (#algCertSlot) — её тексты и цены
 *     серверные, поэтому элемент ПЕРЕЕЗЖАЕТ, а не собирается заново;
 *   • поле «Имя для сертификата» и список того, что внутри документа;
 *   • park()  — отдать кассе номер прогона и его ключ: прогон и так лежит на
 *     сервере с первого задания, откладывать нечего;
 *   • issue() — выдать документ вошедшему (перк плана или токены решает сервер);
 *   • возврат из кассы `?alg_paid=<прогон>` — забрать оплаченное.
 *
 * В браузере нет ни одной цифры документа: сервер собирает его из результата,
 * который сам сохранил в конце прогона.
 *
 * ES2018-safe, обычный скрипт (defer).
 */
(function () {
'use strict';

var PERK = 'algebra_report';
var RUN = null;       // {id, token} прогона на экране
var DATA = null;      // результат (для «недостоверен ли прогон»)
var CLAIMED = false;

function T(key) {
    var d = (window.__ALG && window.__ALG.T) || {};
    return typeof d[key] === 'string' ? d[key] : '';
}
function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}
function ae(stage, extra) {
    try { window.__aeFunnel && window.__aeFunnel(stage, extra || {}); } catch (e) {}
}
function csrf() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
}

/* Анонимному страница приходит из кэша с чужим токеном — ждём общий __csrfReady(). */
function post(url, body) {
    var ready = (typeof window.__csrfReady === 'function') ? window.__csrfReady() : Promise.resolve(null);
    return ready.then(function () {
        return fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrf()
            },
            body: JSON.stringify(body || {})
        }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) {
                j = j || {};
                j.__status = r.status;
                return j;
            });
        });
    });
}

function gate() { return document.querySelector('[data-perk-gate][data-perk="' + PERK + '"]'); }
function nameValue() {
    var el = document.getElementById('algCertName');
    return el ? String(el.value || '').trim().slice(0, 60) : '';
}
function status(msg, kind) {
    var el = document.getElementById('algCertStatus');
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'alg-cert-status' + (kind ? ' ' + kind : '');
    el.hidden = !msg;
}

/* ── касса и выдача ───────────────────────────────────────────────────── */

/** Касса получает номер прогона, ключ и имя — прогон уже на сервере. */
function park() {
    if (!RUN) return Promise.resolve(null);
    return Promise.resolve({ ref: RUN.id, token: RUN.token, name: nameValue() });
}

function issue() {
    if (!RUN) return Promise.resolve({ ok: false, error: 'no_result' });
    return post('/api/algebra-report', {
        run: RUN.id,
        token: RUN.token,
        holder_name: nameValue()
    }).then(function (j) {
        if (!j || !j.ok) return { ok: false, error: (j && j.error) || 'failed' };
        return { ok: true, download: j.download, name: j.name, certified: j.certified };
    }).catch(function () { return { ok: false, error: 'network' }; });
}

/**
 * Файл забираем blob'ом через общий примитив: прямой переход увёл бы со
 * страницы результата, а <a download> на blob молча не работает в Android
 * WebView (за это отвечает __downloadFile).
 */
function download(url, name) {
    fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.blob() : Promise.reject(r.status); })
        .then(function (blob) {
            if (window.__downloadFile) window.__downloadFile(blob, name || 'algebra.pdf');
            else window.location.href = url;
        })
        .catch(function () { window.location.href = url; });
}

function renderIssued(url, name) {
    status(T('cert_ready'), 'ok');
    var again = document.getElementById('algCertAgain');
    if (again) {
        again.hidden = false;
        again.onclick = function () { download(url, name); };
    }
}

/* ── экран результата ─────────────────────────────────────────────────── */

function slotHtml(res) {
    var items = ['cert_inc_steps', 'cert_inc_plan', 'cert_inc_book', 'cert_inc_cert']
        .map(function (k) { return T(k); }).filter(Boolean);
    // Без сертификата — недостоверный или досрочно законченный прогон.
    var unc = res && (res.valid === false || (res.flags || []).indexOf('early') >= 0);
    var note = unc && T('cert_uncertified')
        ? '<p class="alg-cert-note">' + esc(T('cert_uncertified')) + '</p>' : '';
    return '<div class="alg-cert">'
        + '<h3 class="alg-h3">' + esc(T('cert_title')) + '</h3>'
        + (items.length ? '<ul class="alg-cert-inc">' + items.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul>' : '')
        + note
        + '<label class="alg-lbl" for="algCertName">' + esc(T('cert_name_label')) + '</label>'
        + '<input class="alg-in alg-cert-in" id="algCertName" type="text" maxlength="60" autocomplete="name"'
        + ' placeholder="' + esc(T('cert_name_hint')) + '">'
        + '<div class="alg-cert-gate" id="algCertGateSlot"></div>'
        + '<div class="alg-cert-status" id="algCertStatus" role="status" hidden></div>'
        + '<button type="button" class="alg-btn ghost" id="algCertAgain" hidden>' + esc(T('cert_again')) + '</button>'
        + '</div>';
}

/** Карточка переезжает в слот результата — и обратно домой перед перерисовкой. */
function relocate() {
    var g = gate();
    var slot = document.getElementById('algCertGateSlot');
    if (g && slot && g.parentNode !== slot) slot.appendChild(g);
}
function unmount() {
    var g = gate();
    var home = document.getElementById('algGateHome');
    if (g && home && g.parentNode !== home) home.appendChild(g);
    /* Перерисовка страницы зовёт unmount на КАЖДОМ экране (каждое задание).
     * Сбрасывать контекст есть смысл, только если результат был: иначе каждое
     * задание стоило запроса состояния карточки и события «карточка
     * показана» — у скрытой карточки (замер сценарием: 9 «показов» за тест). */
    if (!RUN) return;
    RUN = null;
    DATA = null;
    // Контекст прежнего результата снимается: касса не должна нести его номер.
    try { window.__perkGate && window.__perkGate.setContext(PERK, {}); } catch (e) {}
}

var registered = false;
function register() {
    if (registered || !window.__perkGate) return;
    registered = true;
    window.__perkGate.register(PERK, {
        park: park,
        issue: issue,
        onIssued: function (res) {
            if (res && res.download) {
                ae('report_issued', { certified: res.certified ? 1 : 0 });
                download(res.download, res.name);
                renderIssued(res.download, res.name);
            }
        }
    });
}

function mount(run, data) {
    var host = document.getElementById('algCertSlot');
    if (!host || !run || !run.id) return;
    RUN = { id: run.id, token: run.token };
    DATA = data || null;
    host.innerHTML = slotHtml(DATA && DATA.result);
    relocate();
    register();
    try { window.__perkGate && window.__perkGate.setContext(PERK, { ref: RUN.id, token: RUN.token, name: '' }); } catch (e) {}
    var input = document.getElementById('algCertName');
    if (input) {
        try {
            var saved = window.__toolSettings && window.__toolSettings.load('algebra-test', 'cert_name', '');
            if (saved) input.value = saved;
        } catch (e) {}
        // Имя, вписанное после открытия карточки, обязано доехать до назначения
        // платежа: иначе оплаченный сертификат выйдет без имени.
        input.addEventListener('change', function () {
            try { window.__toolSettings && window.__toolSettings.save('algebra-test', 'cert_name', nameValue()); } catch (e) {}
            if (!RUN || !window.__perkGate) return;
            window.__perkGate.setContext(PERK, { ref: RUN.id, token: RUN.token, name: nameValue() });
        });
    }
    ae('report_card_shown', {});
}

/* ── возврат из кассы ─────────────────────────────────────────────────── */

/**
 * `?alg_paid=<прогон>`: документ почти всегда уже собран вебхуком — забираем
 * его сами, чтобы человек ПОЛУЧИЛ файл, а не искал. Работает и без
 * результата на экране: заплативший с телефона или через сутки видит обычный
 * стартовый экран.
 */
function claimPaid() {
    var m = /[?&]alg_paid=(\d+)/.exec(window.location.search || '');
    if (!m || CLAIMED) return;
    CLAIMED = true;
    try {
        var clean = window.location.pathname
            + window.location.search.replace(/([?&])alg_paid=\d+&?/, '$1').replace(/[?&]$/, '');
        window.history.replaceState({}, '', clean);
    } catch (e) {}

    var box = document.getElementById('algPaidNotice');
    var say = function (msg, kind) {
        if (!box) return;
        box.textContent = msg;
        box.className = 'alg-paid-notice' + (kind ? ' ' + kind : '');
        box.hidden = !msg;
    };
    ae('report_paid_return', { ref: m[1] });
    say(T('cert_claiming'));
    post('/api/algebra-report/claim', { ref: +m[1] }).then(function (j) {
        if (j && j.ok && j.download) {
            say(T('cert_ready'), 'ok');
            download(j.download, j.name);
            return;
        }
        /* Не вошёл (аккаунт на эту почту уже был — касса в него не входит)
         * или документ ещё собирается: он уже ушёл письмом со ссылкой. */
        say(T('cert_emailed'));
    }).catch(function () { say(T('cert_emailed')); });
}

/* Обработчики объявляются сразу, а не на первом результате: объявление
 * перерисовывает карточку (запрос состояния), и на экране результата их было
 * два подряд — объявление и контекст прогона. */
function boot() {
    claimPaid();
    // perk-gate.js подключён ниже по странице (стек scripts) и к этому
    // моменту может ещё не выполниться — тогда ждём конца разбора.
    if (window.__perkGate) register();
    else document.addEventListener('DOMContentLoaded', register);
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}

window.AlgReport = { mount: mount, unmount: unmount };
})();
